import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { WorkflowAutoUpload } from 'app/models/workflow-auto-upload';
import { WorkflowFile } from 'app/models/workflow-file';
import { WorkflowWizardService } from 'app/services/workflow-wizard.service';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowAutoUploadService } from 'app/services/workflow-auto-upload.service';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { FormGroup, FormArray } from '@angular/forms';
import { AddSaveRuleComponent } from '../add-save-rule/add-save-rule.component';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
import { WorkflowForm } from 'app/models/workflow-form';

@Component({
  selector: 'app-save-rules',
  templateUrl: './save-rules.component.html',
  styleUrls: ['./save-rules.component.scss']
})
export class SaveRulesComponent implements OnInit {

  constructor(public workflowWizardService: WorkflowWizardService, private workflowTemplateService: WorkflowTemplateService) { }

  ngOnInit() {
    this.allForms = this.workflowTemplateService.getParentForms(this.workflowStepCompletionFormGroup.root as FormGroup, this.workflowStepCompletionFormGroup.value.name, 
          (this.workflowWizardService.currentStep && this.workflowWizardService.currentStep.value && this.workflowWizardService.currentStep.value.name)? 
            this.workflowWizardService.currentStep.value.name: null);

    this.allFiles = this.workflowTemplateService.getParentFiles(this.workflowStepCompletionFormGroup.root as FormGroup, this.workflowStepCompletionFormGroup.value.name, 
          (this.workflowWizardService.currentStep && this.workflowWizardService.currentStep.value && this.workflowWizardService.currentStep.value.name)? 
            this.workflowWizardService.currentStep.value.name: null);

    this.setAutoUploadsList();
    this.workflowStepCompletionFormGroup.valueChanges.subscribe(() => {
      this.setAutoUploadsList();      
    });
  }

  setAutoUploadsList() {
    this.autoUploads = this.workflowStepCompletionFormGroup.value.auto_uploads;
  }

  @Input() workflowStepCompletionFormGroup: FormGroup;
  @Input() forExecution: boolean = false;

  autoUploads: WorkflowAutoUpload[] = [];

  allFiles: WorkflowFile[];
  allForms: WorkflowForm[];

  tableLimitSelect = [5, 10, 20, 30, 50, 100];
  selectedAutoUploadTableLimit: number = 5;

  editRuleIndex: number = -1;

  @ViewChild('addEditSaveRule', { static: true }) addEditSaveRule: AddSaveRuleComponent;

  editAutoSaveRule(autoUpload: WorkflowAutoUpload, index: number){
    this.editRuleIndex = index;
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowAutoUploadFormGroup(autoUpload, this.forExecution);
    formGroupPatchValueNullFriendly(frmGroup, autoUpload);
    this.addEditSaveRule.show(frmGroup);
  }

  deleteAutoSaveRule(autoUpload: WorkflowAutoUpload, index: number){
    let autoUploadsFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['auto_uploads'] as FormArray);
    autoUploadsFormArray.removeAt(index);
  }

  onAddEditFinished(frm: FormGroup) {
    let autoUploadsFormArray: FormArray = (this.workflowStepCompletionFormGroup.controls['auto_uploads'] as FormArray);

    if (this.editRuleIndex != -1) {
      (<FormGroup>autoUploadsFormArray.controls[this.editRuleIndex]).controls['additional_paths'] = frm.controls['additional_paths'];
      frm.get('additional_paths').setParent(<FormGroup>autoUploadsFormArray.at(this.editRuleIndex));

      (<FormGroup>autoUploadsFormArray.controls[this.editRuleIndex]).controls['metadata'] = frm.controls['metadata'];
      frm.get('metadata').setParent(<FormGroup>autoUploadsFormArray.at(this.editRuleIndex));

      formGroupPatchValueNullFriendly(autoUploadsFormArray.at(this.editRuleIndex) as FormGroup, frm.value);
      this.editRuleIndex = -1;
    } else {
      autoUploadsFormArray.push(frm);
      frm.setParent(autoUploadsFormArray);
    }
  }
  
  onAddNewRule() {
    this.editRuleIndex = -1;
    let frmGroup: FormGroup = this.workflowTemplateService.getWorkflowAutoUploadFormGroup({} as WorkflowAutoUpload);
    this.addEditSaveRule.show(frmGroup);
  }
}
